module.exports = __webpack_public_path__ + "public/img/psw.671a123f.png";